<script>
  import {
    faInfoCircle,
    faXmark,
    faCircleInfo,
  } from "@fortawesome/pro-solid-svg-icons";
  import { Icon, Flex, Button } from "@gl/design-system";
  import { clickOutside } from "../utils/clickOutside";

  export let title;
  export let open = false;
  export let tooltipTop = "10px";
  export let tooltipLeft = "15px";
  export let tooltipRight = null;
</script>

<div class="info-wrapper">
  <Button
    transparent
    on:click={() => (open = !open)}
    style="padding:0; margin-top:-2px"
    class="ml-2"
  >
    <Icon icon={faCircleInfo} class="color-info" />
  </Button>

  {#if open}
    <div
      class="info-container"
      style="top:{tooltipTop}; left:{tooltipLeft}; right:{tooltipRight}"
      use:clickOutside
      on:click_outside={() => {
        open = false;
      }}
    >
      <Flex>
        <Icon icon={faInfoCircle} class="color-info mr-2" />

        <div class="flex-grow-1">
          <b>{title}</b>
        </div>

        <button class="info-close" on:click={() => (open = false)}>
          <Icon icon={faXmark} scale={0.9} />
        </button>
      </Flex>

      <div class="info-text mt-3">
        <slot />
      </div>
    </div>
  {/if}
</div>

<style>
  .info-wrapper {
    position: relative;
    width: 100%;
  }
  .info-close {
    color: var(--gl-scheme-white);
    background-color: var(--gl-primary);
    height: 18px;
    width: 18px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .info-close:hover {
    background-color: var(--gl-primary-bis);
  }
  .info-container {
    background-color: var(--gl-scheme-white);
    padding: 16px 20px;
    min-width: 300px;
    width: 100%;
    max-width: 380px;
    position: absolute;
    z-index: 20;
    box-shadow: 0px 4px 4px 0px #00000040;
    text-wrap: auto;
  }

  button {
    background: none;
    color: var(--gl-text);
    font-weight: 600;
    border: none;
    height: 24px;
  }

  .info-text {
    word-break: break-word;
    text-wrap: wrap;
  }
</style>
